import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { formatFileSize } from '@/utils/storage';
import { StorageTooltip } from './StorageTooltip';

export interface StorageSlice {
    key: 'cameras' | 'videos' | 'other';
    label: string;
    value: number;
    color: string;
    [k: string]: string | number;
}

interface StorageBreakdownProps {
    slices: StorageSlice[];
    label: string;
}

export function StorageBreakdown({ slices, label }: StorageBreakdownProps) {
    const total = slices.reduce((sum, slice) => sum + slice.value, 0);

    return (
        <div className="border border-grey-600 rounded-[10px] p-4 flex flex-col gap-4 @medium:flex-row @medium:items-center">
            <div className="flex flex-col gap-1">
                <span className="text-sm text-grey-200">{label}</span>
                <span className="text-lg text-white leading-7">
                    {formatFileSize(total)}
                </span>
            </div>
            <div className="flex-1 flex items-center gap-4 min-h-[140px]">
                <div className="w-[140px] h-[140px]">
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={slices}
                                dataKey="value"
                                nameKey="label"
                                innerRadius={40}
                                outerRadius={65}
                                paddingAngle={total > 0 ? 2 : 0}
                                stroke="none"
                            >
                                {slices.map((slice) => (
                                    <Cell key={slice.key} fill={slice.color} />
                                ))}
                            </Pie>
                            <Tooltip
                                content={<StorageTooltip total={total} />}
                            />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
                <div className="flex flex-col gap-2">
                    {slices.map((slice) => (
                        <div
                            key={slice.key}
                            className="flex items-center gap-2 text-xs"
                        >
                            <span
                                className="inline-block size-2.5 rounded-full"
                                style={{ backgroundColor: slice.color }}
                            />
                            <span className="text-grey-200">{slice.label}</span>
                            <span className="text-white-100">
                                {formatFileSize(slice.value)}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
